import React, { useEffect, useState } from "react";
import "@progress/kendo-react-intl";
import "@progress/kendo-react-dropdowns";
import Modalposting from "../Postings/PostingModal.jsx";
import "react-router-dom";
import MattersCombobox from "../Postings/MattersComboBox.jsx";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Checkbox, RadioGroup } from "@progress/kendo-react-inputs";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { Label } from "@progress/kendo-react-labels";
import { HandleGridBody } from "components/common/HandleGridBody.js";
import {
    AmountFormatCell,
    DateFormatCell,
    formatDateForAPI, AmountFormat,
} from "components/common/formatter.js";
import { Button } from "@progress/kendo-react-buttons";
import BatchPostings from "pages/BatchPosting/index.jsx";
import { Dialog } from "@progress/kendo-react-dialogs";
import CalenderCustomToggleButton from "components/common/CalenderCustomToogleButton.jsx";
import { handleApiError } from "Helper/index.js";
import * as api from "../../api/index.js";
import { AuthorizeChits } from "../../api/accountsAPI.js";
import DocumentViewer from "components/common/DocumentViewer";
import ChitImports from "pages/ChitRequest/ImportChits.jsx";
import ChitRequest from "pages/ChitRequest/ChitRequest.jsx";
import { toast } from "react-toastify";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { useActiveVats } from "services/vatService";
import { useActiveBranches } from "services/branchService.js";
import { useCurrentUser } from "services/currentUserService.js";
import { useActiveFeeEarner } from "services/userService.js";
import { getPostingTypes } from "services/postingTypesService.js";
import { useActiveSuppliers } from "services/supplierService.js";
import { useCompany } from "services/companyService.js";
import { arrowRotateCwIcon } from "@progress/kendo-svg-icons";
import { GridLoader } from "components/GridLoader.jsx";
import DocumentIconCounter from "components/common/DocumentIconCounter.jsx";

const PostingStatus = [
    {
        label: "Unposted",
        value: "false",
    },
    {
        label: "Posted",
        value: "true",
    },
    {
        label: "All",
        value: "",
    },
];

const ChitPosting = (props) => {
    const date = new Date();
    const [modalvalue, setmodalvalue] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [showBatchPosting, setShowBatchPosting] = useState(false);
    const [checkedList, setCheckedList] = useState([]);
    const [selectedList, setSelectedList] = useState([]);
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date()?.toISOString().split("T")[0]);
    const [fileData, setFileData] = useState([]);
    const [showDoc, setShowDoc] = useState(false);
    const [chitRequestModal, setChitRequestModal] = useState(false);
    const [selectedChit, setSelectedChit] = useState(null);
    const { data: user } = useCurrentUser();
    const { data: branchesList, loading: branchesLoading } = useActiveBranches();
    const { data: feeearnerdata } = useActiveFeeEarner();
    const [matterref, setmatterref] = useState(null);
    const [list, setLists] = useState({
        data: [],
        total: 20,
    });
    const [filterParameters, setFilterParmeters] = useState({
        postingStatus: "false",
    });
    const [valueFrom, setValueFrom] = useState(false);
    const [valueTo, setValueTo] = useState(false);
    const [dataState, setDataState] = useState({
        take: 200,
        skip: 0,
        sort: [
            {
                field: "matterRef",
                dir: "asc",
            },
        ],
    });
    const [valuePosting, setValuePosting] = useState([]);
    const [fromDateSelector, setFromDateSelector] = useState(date);
    const [postingStatus, setPostingStatus] = useState("false");
    const [showImports, setShowImports] = useState(false);
    const [selectAll, setSelectAll] = useState(false);
    const [authorized, setAuthorized] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const [postingTypes, setPostingTypes] = useState([]);
    const { data: suppliersdata } = useActiveSuppliers();

    const { activeVats } = useActiveVats();

    const fetchData = async () => {
        try {
            const postingData = await getPostingTypes("chits");
            if (!Array.isArray(postingData) || postingData.length === 0) return;
            setPostingTypes(postingData);
        } catch (error) {
            console.error("Failed to fetch posting types:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [props.name]);

    const [toDateSelector, setToDateSelector] = useState(date);
    const { data: company } = useCompany();
    const onChangeFromDateSelect = (event) => {
        setFromDateSelector(event.value);
        let fromDate = null;
        let date = new Date(event.value);
        if (event.value) {
            fromDate = formatDateForAPI(date);
        }
        setFromDate(fromDate);
        setValueFrom(true);
    };
    const onChangeToDateSelect = (event) => {
        setToDateSelector(event.value);
        let toDate = null;
        let date = new Date(event.value);
        if (event.value) {
            toDate = formatDateForAPI(date);
        }
        setToDate(toDate);
        setValueTo(true);
    };

    useEffect(() => {
        if (company.yearStartDate !== undefined) {
            let yearsToStartDate = new Date(company.yearStartDate);
            setFromDateSelector(yearsToStartDate);
            setFromDate(formatDateForAPI(yearsToStartDate));
        }
    }, [company.yearStartDate]);

    const onChangePosting = (event) => {
        setValuePosting([...event.value]);
    };

    const createState = (skip, take) => {
        let pagerSettings = {
            pageSizes: [10, 25, 50, 100, 200],
        };
        return {
            pageSize: take,
            pageable: pagerSettings,
        };
    };
    const [state, setState] = useState(createState(0, 10));

    const changePostingStatus = (e) => {
        setPostingStatus(e.value);
    };
    const onChangematter = (event) => {
        if (event.target.value !== null && event.target.value !== undefined) {
            setmatterref(event?.target?.value?.matterId);
        } else {
            setmatterref(null);
        }
    };
    const dataStateChange = (e) => {
        if (
            e.dataState.sort !== undefined &&
            e.dataState.skip !== 0 &&
            dataState.sort !== e.dataState.sort
        ) {
            setDataState({ ...e.dataState, skip: 0 });
        } else if (e.dataState.sort[0] === undefined) {
            setDataState({
                ...e.dataState,
                sort: [
                    {
                        field: dataState.sort[0].field,
                        dir: "asc",
                    },
                ],
            });
        } else {
            setDataState(e.dataState);
        }
    };

    const handleChitTypeClick = (chitData) => {
        if (chitData.chitId) {
            // Create activity data structure similar to CaseActivitiesPage
            const activityData = {
                chitRequestId: chitData.chitId,
                details: chitData.details,
                date: chitData.date,
                feeEarnerRef: chitData.feeEarnerRef,
                ...chitData,
                // systemType: 'Accounts',
                // subType: 'ChitRequest'
            };
            setSelectedChit(activityData);
            setChitRequestModal(true);
        }
    };

    const TypeCell = (props) => {
        return (
            <td className="fs-sm wrap-text">
                {props.dataItem.chitId ? (
                    <u
                        style={{ cursor: "pointer" }}
                        onClick={() => handleChitTypeClick(props.dataItem)}
                    >
                        {props.dataItem.postingType?.code}
                    </u>
                ) : (
                    props.dataItem.postingType?.code
                )}
            </td>
        );
    };

    const PostHeaderCell = () => {
        return (
            <td>
                <Checkbox checked={selectAll} onChange={handleSelectAll} />
            </td>
        );
    };

    const handleSelectAll = () => {
        const newSelectAll = !selectAll;
        setSelectAll(newSelectAll);

        setLists((prevList) => {
            const updatedData = prevList.data.map((item) => {
                item.select = newSelectAll;
                return item;
            });

            setCheckedList(
                newSelectAll ? updatedData.map((item) => item.chitId) : []
            );

            return { ...prevList, data: updatedData };
        });
    };

    const PostCell = (props) => {
        return (
            <td>
                {props.dataItem.posted === false &&
                    !props.dataItem.authorizationRequired ? (
                    <Checkbox
                        type="checkbox"
                        checked={props.dataItem.select === true}
                        onChange={() => {
                            setLists((prevList) => {
                                const updatedData = prevList.data.map((item) => {
                                    if (item.chitId === props.dataItem.chitId) {
                                        item.select = !item.select;

                                        if (item.select) {
                                            setCheckedList((prevList) => [...prevList, item.chitId]);
                                        } else {
                                            setCheckedList((prevList) =>
                                                prevList.filter((id) => id !== item.chitId)
                                            );
                                        }
                                    }
                                    return item;
                                });
                                setSelectAll(updatedData.every((item) => item.select));
                                return { ...prevList, data: updatedData };
                            });
                        }}
                    />
                ) : null}
            </td>
        );
    };

    const filterParamatersBinding = () => {
        setIsLoading(true);
        let parameters = {};

        if (matterref !== null) {
            parameters.matterId = matterref;
        }

        if (valuePosting.length !== 0) {
            parameters.postingTypes = valuePosting.map((p) => p.code);
        }

        parameters.postingStatus = postingStatus;

        if (valueFrom) {
            parameters.fromDate = fromDate;
        }

        if (valueTo) {
            parameters.toDate = toDate;
        }

        setFilterParmeters(parameters);
    };

    useEffect(() => {
        filterParamatersBinding();
    }, [
        postingStatus,
        valueFrom && fromDateSelector,
        valueTo && toDateSelector,
        valuePosting,
        matterref,
        valueFrom,
        valueTo,
    ]);

    const addToBatch = () => {
        const data = list.data.filter((item) => item.select === true);

        const transformedData = data.map((item) => {
            const supplierName = suppliersdata?.find(
                (s) => s.supplierRef === item.supplierRef
            )?.supplierName;
            const branchName = branchesList?.find(
                (b) => b.branchId === item.branchId
            )?.branchName;
            const vatName = activeVats?.find(
                (v) => v.vatCodeId === item.vatCode
            )?.representation;
            return {
                ...item,
                postingCode: item.postingType,
                date: new Date(item.date),
                matterID:
                    typeof item.matterID !== "object"
                        ? {
                            matterRef: item.matterRef,
                            matterId: item.matterID,
                        }
                        : item.matterID,
                supplierRef:
                    item.supplierRef && typeof item.supplierRef !== "object"
                        ? {
                            supplierRef: item.supplierRef,
                            representation: supplierName
                                ? `${supplierName} - ${item.supplierRef}`
                                : item.supplierRef,
                        }
                        : item.supplierRef,
                nominalRef:
                    item.nominalRef && typeof item.nominalRef !== "object"
                        ? {
                            nominalRef: item.nominalRef,
                            representation: `${item.nominalInfo?.nominalRef} - ${item.nominalInfo?.nominalName}`,
                        }
                        : item.nominalRef,
                ddaBank:
                    item.ddaBank && typeof item.ddaBank === "object"
                        ? {
                            ...item.ddaBank,
                            representation: `${item.ddaBank?.nominalRef} - ${item.ddaBank?.nominalName}`,
                        }
                        : item.ddaBank,
                officeBank:
                    item.officeBank && typeof item.officeBank === "object"
                        ? {
                            ...item.officeBank,
                            representation: `${item.officeBank?.nominalRef} - ${item.officeBank?.nominalName}`,
                        }
                        : item.officeBank,
                clientBank:
                    item.clientBank && typeof item.clientBank === "object"
                        ? {
                            ...item.clientBank,
                            representation: `${item.clientBank?.nominalRef} - ${item.clientBank?.nominalName}`,
                        }
                        : item.clientBank,
                feeEarnerRef:
                    item.feeEarnerRef && typeof item.feeEarnerRef === "object"
                        ? {
                            ...item.feeEarnerRef,
                            representation: `${item.feeEarnerRef?.userRef} - ${item.feeEarnerRef?.displayname}`,
                        }
                        : item.feeEarnerRef,

                branchId:
                    item.branchId && typeof item.branchId !== "object"
                        ? {
                            branchId: item.branchId,
                            representation: branchName
                                ? `${branchName} - ${item.branchId}`
                                : item.branchId,
                        }
                        : item.branchId,

                vatCode:
                    item.vatCode && typeof item.vatCode !== "object"
                        ? {
                            vatCode: item.vatCode,
                            representation: vatName,
                        }
                        : item.vatCode,
            };
        });

        setSelectedList(transformedData);
        if (props.component === "batchPosting") {
            props.onAddToBatch(transformedData);
            props.onClose();
        } else {
            setShowBatchPosting(true);
        }
    };
    const authorizeChit = async () => {
        const data = authorized.map((chitId) => ({
            chitID: chitId,
        }));

        try {
            const response = await AuthorizeChits(data);
            if (response.status === 200) {
                handleRefresh();
                toast.success("Chit authorised successfully");
            }
        } catch (error) {
            handleApiError(error);
        }
    };

    const dataReceived = (list) => {
        if (list.data) {
            list?.data?.map((item) => {
                item.select = false;
                item.postingField = postingTypes?.filter(
                    (item1) => item.postingType === item1.code
                )[0];
                item.postingType = item.postingField;
                if (
                    item?.postingField?.code === "DCR" ||
                    item?.postingField?.code === "DDR"
                ) {
                    item.ddaBank = item.nominalInfo;
                }
                if (
                    item?.postingField?.code === "CCR" ||
                    item?.postingField?.code === "CDR"
                ) {
                    item.clientBank = item.nominalInfo;
                }
                if (
                    item?.postingField?.code === "OCR" ||
                    item?.postingField?.code === "ODR" ||
                    item?.postingField?.code === "DPU"
                ) {
                    item.officeBank = item.nominalInfo;
                }
                item.feeearner = feeearnerdata.filter(
                    (item1) => item.feeEarnerRef === item1.userRef
                )[0];
                item.feeEarnerRef = item.feeearner;
                checkedList.map((item1) => {
                    if (item.chitId === item1) {
                        item.select = true;
                    }
                });
            });

            if (props.component === "batchPosting") {
                const data = list.data.filter(
                    (item) => item.postingField?.code === props.postingType
                );
                setLists({
                    data: data,
                    total: data.length,
                });
                return;
            }
            setLists(list);
            setIsLoading(false);
        }
    };
    const handleRefresh = () => {
        setAuthorized([]);
        setCheckedList([]);
        setSelectAll(false);
        setRefresh(!refresh);
        setIsLoading(true);
    };

    const postingDoc = async (chitId) => {
        // setShow(!show);
        try {
            const { data } = await api.getChitDocuments(chitId);
            setFileData(data.data);

            setShowDoc(true);
        } catch (error) {
            handleApiError(error);
        }
    };

    const DocumentCounterCell = (e) => {
        return (
            <td>
                <DocumentIconCounter
                    count={e.dataItem.documentCount}
                    onClick={() => postingDoc(e.dataItem.chitId)}
                />
            </td>
        );
    };

    const AuthorizationCell = (e) => {
        const handleAuthorizationChange = () => {
            setLists((prevList) => {
                const updatedData = prevList.data.map((item) => {
                    if (item.chitId === e.dataItem.chitId) {
                        item.auth = !item.auth;

                        if (item.auth) {
                            setAuthorized((prevList) => [...prevList, item.chitId]);
                        } else {
                            setAuthorized((prevList) =>
                                prevList.filter((id) => id !== item.chitId)
                            );
                        }
                    }
                    return item;
                });
                return { ...prevList, data: updatedData };
            });
        };

        const isDisabled =
            e.dataItem.excludedAuthUsers.includes(user.userRef) ||
            (!user?.profile?.accounts.AuthorizationLevel1 &&
                !user?.profile?.accounts.AuthorizationLevel2 &&
                !user?.profile?.accounts.AuthorizationLevel3);

        const tooltipMessage = e.dataItem.excludedAuthUsers.includes(user.userRef)
            ? `User '${user.userRef}' cannot authorise multiple levels of the same Chit Request`
            : "You do not have the required authorisation level to authorise this Chit Request";

        return (
            <td>
                {e.dataItem?.authorizationRequired ? (
                    <Tooltip
                        anchorElement="target"
                        position="top"
                        parentTitle
                        style={{
                            maxWidth: "275px",
                        }}
                    >
                        <span title={isDisabled ? tooltipMessage : ""}>
                            <Checkbox
                                className="cursor-pointer"
                                checked={e.dataItem.auth}
                                onChange={handleAuthorizationChange}
                                disabled={isDisabled}
                            />
                        </span>
                    </Tooltip>
                ) : null}
            </td>
        );
    };


    const GrossAmountCell = (props) => {
        const gross = (props.dataItem.netAmount || 0) + (props.dataItem.vatAmount || 0);
        return (
            <td className="text-end">
                <span>{AmountFormat(gross)}</span>
            </td>
        );
    };

    const AmountNameHeader = (props) => {
        return (
            <div
                onClick={(e) => {
                    props.onClick(e);
                }}
                style={{ textAlign: "center", cursor: "pointer" }}
            >
                {props.title}
                {props.children}
            </div>
        );
    };


    return (
        <>
            <div className="page h-100 d-flex flex-column">

                {showDoc && (
                    <DocumentViewer data={fileData} onClose={() => setShowDoc(false)} />
                )}

                {props.component !== "batchPosting" && (

                    <div className="row">
                        <div className="col-12 d-flex flex-wrap align-items-start justify-content-start ">
                            <div className="d-flex flex-column mb-2 me-3">
                                <Label className="mb-2 filter-font">Posting Type</Label>
                                <MultiSelect
                                    data={postingTypes}
                                    onChange={onChangePosting}
                                    textField="code"
                                    value={valuePosting}
                                    className="dropdown-width"
                                    size={"small"}
                                />
                            </div>

                            <div className="d-flex flex-column me-3 mb-1">
                                <Label className="mb-2 filter-font">Matter</Label>
                                <MattersCombobox
                                    onChangematter={onChangematter}
                                    className="dropdown-width"
                                />
                            </div>

                            <div className="me-2  mt-1">
                                <div className="nominal-form-to-parent-row">
                                    <div className="labels-containers">
                                        <Label editorId={"dp"}>From</Label>
                                        <div className="label-to">
                                            <Label editorId="to">To</Label>
                                        </div>
                                    </div>
                                </div>
                                <div className="nominal-form-to-row">
                                    <div
                                        className="date-form-to-wrapper"
                                        style={{ height: "40px" }}
                                    >
                                        <div className="from">
                                            <div className="d-flex align-items-center justify-content-center">
                                                <Checkbox
                                                    value={valueFrom}
                                                    className="ms-2 me-1"
                                                    onChange={(e) => {
                                                        setValueFrom(e.value);
                                                    }}
                                                    label={""}
                                                />
                                                <DatePicker
                                                    id="from"
                                                    className="date-picker"
                                                    value={fromDateSelector || null}
                                                    onChange={onChangeFromDateSelect}
                                                    toggleButton={CalenderCustomToggleButton}
                                                />
                                            </div>
                                        </div>
                                        <div className="divider"></div>
                                        <div className="to">
                                            <div className="d-flex align-items-center justify-content-center">
                                                <Checkbox
                                                    value={valueTo}
                                                    className="ms-2 me-1"
                                                    onChange={(e) => {
                                                        setValueTo(e.value);
                                                    }}
                                                    label={""}
                                                />
                                                <DatePicker
                                                    id="to"
                                                    className="date-picker"
                                                    value={toDateSelector || null}
                                                    onChange={onChangeToDateSelect}
                                                    toggleButton={CalenderCustomToggleButton}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="ms-auto d-flex">

                                <div className="d-flex flex-column radio">
                                    <Label className="filter-font pb-1">Type</Label>
                                    <RadioGroup
                                        data={PostingStatus}
                                        onChange={changePostingStatus}
                                        defaultValue={PostingStatus[0].value}
                                        className="d-flex flex-row mt-1  radio-group-gap"
                                    />
                                </div>

                                <div className="mt-3 ">
                                    <Button
                                        className="common-btn"
                                        onClick={handleRefresh}
                                        svgIcon={arrowRotateCwIcon}
                                    >
                                        <span className="d-flex align-items-center">
                                            <span className="d-xl-inline-block d-sm-none ms-1">
                                                Refresh
                                            </span>
                                        </span>
                                    </Button>
                                </div>

                            </div>
                        </div>
                    </div>
                )}

                <div className="flex-grow-1 overflow-auto mt-3">
                    <Grid
                        {...dataState}
                        data={list}
                        onDataStateChange={dataStateChange}
                        className="fs-md h-100 grid-minwidth-col4-150"
                        sortable={true}
                        pageable={state.pageable}
                        pageSize={state.pageSize}
                        showLoader={isLoading}
                        loader={<GridLoader />}
                    >
                        <GridNoRecords>
                            {isLoading ? (
                                <div style={{ height: "110px" }}></div>
                            ) : (
                                list.data && list.data.length === 0 && "No records available"
                            )}
                        </GridNoRecords>
                        <GridColumn
                            field="postingType.code"
                            title="Type"
                            width="80px"
                            cell={TypeCell}
                        />
                        <GridColumn field="matterRef" title="Matter" width="120px" />
                        <GridColumn
                            field="date"
                            title="Date"
                            cell={DateFormatCell}
                            width="100px"
                        />
                        <GridColumn field="details" title="Details" />
                        <GridColumn field="supplierRef" title="Supplier" width="100px" />
                        <GridColumn
                            field="vatAmount"
                            title="Vat"
                            cell={AmountFormatCell}
                            width="80px"
                            headerCell={AmountNameHeader}
                        />
                        <GridColumn
                            title="Amount"
                            cell={GrossAmountCell}
                            width="120px"
                            headerCell={AmountNameHeader}
                        />
                        <GridColumn
                            field="documentCount"
                            title="Doc"
                            width="60px"
                            cell={DocumentCounterCell}
                            headerClassName="grid-header-center"
                        />
                        <GridColumn
                            field="authorizationRequired"
                            title="Auth"
                            width="80px"
                            cell={AuthorizationCell}
                        />
                        <GridColumn
                            field=""
                            title=""
                            cell={PostCell}
                            width="80px"
                            headerCell={PostHeaderCell}
                            headerClassName="text-center align-middle p-0"
                        />
                    </Grid>
                </div>

                <div className="d-flex justify-content-between mt-3">
                    <div className="col-auto">
                        <Button
                            className="common-btn"
                            type="button"
                            style={{ maxWidth: "130px" }}
                            onClick={() => {
                                setShowImports(true);
                            }}
                        >
                            Import Chits
                        </Button>
                    </div>
                    <div className="col-auto d-flex gap-2">
                        <Button
                            className="common-btn"
                            style={{ maxWidth: "130px" }}
                            onClick={authorizeChit}
                            disabled={authorized.length === 0}
                        >
                            Authorize Chit
                        </Button>
                        <Button
                            className="common-btn"
                            style={{ maxWidth: "130px" }}
                            disabled={checkedList.length === 0}
                            onClick={addToBatch}
                        >
                            Add to Batch
                        </Button>
                    </div>
                </div>
                {showImports && (
                    <ChitImports cancelEdit={() => setShowImports(false)} />
                )}
                <HandleGridBody
                    dataState={dataState}
                    onDataReceived={dataReceived}
                    currentComponent={
                        props.component === "batchPosting" ? "batchPosting" : "chitPosting"
                    }
                    parameters={filterParameters}
                    refresh={refresh}
                    setIsLoading={setIsLoading}
                />
                <Modalposting
                    value={modalvalue}
                    reset={() => {
                        //   resetfields();
                    }}
                    closeModal={() => {
                        setmodalvalue(false);
                    }}
                    component={"Posting"}
                ></Modalposting>
            </div>
            {showBatchPosting && (
                <Dialog
                    style={{ overflow: "hidden" }}
                    title={`Batch Posting`}
                    className="batch-posting-dialog dialog-xxl"
                    onClose={() => {
                        setShowBatchPosting(false);
                    }}
                >
                    <div className="p-2" style={{ overflow: "hidden !important" }}>
                        <BatchPostings
                            type={"chitPosting"}
                            selectedList={selectedList}
                            onClose={() => {
                                setShowBatchPosting(false);
                                handleRefresh();
                            }}
                        />
                    </div>
                </Dialog>
            )}
            {chitRequestModal && (
                <ChitRequest
                    cancelEdit={() => {
                        setChitRequestModal(false);
                        setSelectedChit(null);
                        handleRefresh(); // Refresh the grid after edit
                    }}
                    matter={{
                        matterId: selectedChit?.matterID,
                        matterRef: selectedChit?.matterRef,
                    }}
                    component={"modal"}
                    activityData={selectedChit}
                />
            )}
        </>
    );
};
export default ChitPosting;
